module.exports = __webpack_public_path__ + "img/MapThumb_BabylonianBasin.bfc15d5d.webp";